import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { useUser } from 'store'

const ActionButton = ({ icon, label, onClick }) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 10px',
        minHeight: '24px',
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: '#E0E0E0',
        borderRadius: '24px',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <i className={`fa-light fa-${icon}`} style={{ fontSize: 8, color: '#202939', marginRight: '8px' }} />
      <Typography
        variant="caption"
        sx={{
          fontSize: 10,
          color: 'text.primary',
          textTransform: 'none',
        }}
      >
        {label}
      </Typography>
    </Button>
  );
}

const ActionsMenu = ({
  device
}) => {
  const [user] = useUser()
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const manufacturer = device.manufacturer?.toLowerCase()
  const canConfigure = Boolean(manufacturer && manufacturer !== 'apple')
  const canManage = manufacturer !== 'apple'
  return (
    <Stack direction="row" spacing={1} justifyContent="space-between">
      {
        (!user.demo_mode && canConfigure) && (
          <ActionButton
            icon="gear"
            label={t('stream-cast.actions.setup.tooltip_config')}
            onClick={() => navigate(`./${device.uuid}/setup${location.search}`)}
          />
        )
      }
      {
        (!user.demo_mode && canManage) && (
          <ActionButton
            icon="arrow-right-arrow-left"
            label={t('stream-cast.actions.replace.title')}
            onClick={() => navigate(`./${device.uuid}/replace_${device.kind === 'tv' ? 'tv' : 'chromecast'}${location.search}`)}
          />
        )
      }
      {
        (!user.demo_mode && device.is_reachable && canManage && device.kind === 'tv') && (
          <ActionButton
            icon="arrow-rotate-left"
            label={t('stream-cast.actions.reboot.title')}
            onClick={() => navigate(`./${device.uuid}/reboot${location.search}`)}
          />
        )
      }

    </Stack>
  );
};

export default ActionsMenu;
